import { useState } from "react";
import { useDispatch } from "react-redux";
import { projectSelected, projectUnSelected } from "../../features/projects/ProjectsSlice";


export default function ProjectItem({project}) {
    const dispatch = useDispatch();

    const { id, colorClass, projectName } = project;
    const [isSelected, setIsSelected] = useState(true);

    const handleProjectSelect = (isChecked) => {
        setIsSelected(isChecked);
        
        if (isChecked) {
            dispatch(projectSelected(id));
        }
        else {
            dispatch(projectUnSelected(id));
        }
    }

	return (
		<div className="checkbox-container">
			<input 
                checked={isSelected}
                onChange={() => handleProjectSelect(!isSelected)}
                type="checkbox" 
                className={colorClass}
            />
			<p className="label">{projectName}</p>
		</div>
	);
}
